// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__e62L7","footer-container":"Footer_footer-container__S92qH","footer-icons":"Footer_footer-icons__CN7Uy"};